import brandTheme from 'Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const styles = {
  title: {
    color: colors.primary,
    fontSize: '20px',
  },
  row: {
    margin: '15px 0px 35px',
    display: 'flex',
    alignItems: 'center',
  },
  col: {
    paddingLeft: '0px',
  },
  info: {
    color: '#7F8FA4',
    fontSize: '10px',
    marginTop: '5px',
  },
  success: {
    backgroundColor: '#008450',
  },
  error: {
    backgroundColor: '#B81D13',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/UploadDocuments/UploadDocumentsForm/UploadDocumentItem/styles.js